import RouteComponent from "@/components/RouteComponent.vue";

export default {
  path: "/documents",
  component: RouteComponent,
  children: [
    {
      path: "enterprise",
      name: "documents.enterprise",
      component: () =>
        import(/* webpackChunkName: "documents" */ "@/views/DocumentsView.vue"),
      meta: {
        title: "enterprise-documents",
        header: { show: true },
        navbar: { show: true },
        footer: { show: true },
      },
    },
    {
      path: "project",
      name: "documents.project",
      component: () =>
        import(/* webpackChunkName: "documents" */ "@/views/DocumentsView.vue"),
      meta: {
        title: "project-documents",
        header: { show: true },
        navbar: { show: true },
        footer: { show: true },
      },
    },
    {
      path: "other",
      name: "documents.other",
      component: () =>
        import(/* webpackChunkName: "documents" */ "@/views/DocumentsView.vue"),
      meta: {
        title: "other-documents",
        header: { show: true },
        navbar: { show: true },
        footer: { show: true },
      },
    },
  ],
};
